/** @format */

import type {Field} from '@/types/assets';

export const useTranslation = () => {
  const {locale} = useI18n();

  const translate = (field: Field<string>) => {
    if (field.resources.translation && field.resources.translation.value[locale.value]) {
      return field.resources.translation.value[locale.value];
    }
    return field.value;
  };

  return {
    translate,
  };
};
